import * as actionTypes from './actionTypes';

// 完全回到initstate
export const setRestore = () => ({
    type: actionTypes.SET_RESTORE,
});

// 重置選項，若有月曆回到預選第一天
export const setReset = () => ({
    type: actionTypes.SET_RESET,
});

export const setNowListID = (payload: any) => ({
    type: actionTypes.SET_NOWLISTID,
    payload,
});

export const setNowListData = (payload: any) => ({
    type: actionTypes.SET_NOWLISTDATA,
    payload,
});

export const setDetailData = (payload: any) => ({
    type: actionTypes.SET_DETAILDATA,
    payload,
});

export const setTicketNum = (payload: any) => ({
    type: actionTypes.SET_TICKECTNUM,
    payload,
});

export const setTotalAmount = (payload: any) => ({
    type: actionTypes.SET_TOTALAMOUNT,
    payload,
});

export const setTempCalendarData = (payload: any) => ({
    type: actionTypes.SET_TEMPCALENDARDATA,
    payload,
});

export const setPickCalendar = (payload: any) => ({
    type: actionTypes.SET_PICKCALENDAR,
    payload,
});

export const setIsDetailLoading = (payload: any) => ({
    type: actionTypes.SET_ISDETAILLOADING,
    payload,
});

export const setDetailLoadingFail = (payload: any) => ({
    type: actionTypes.SET_DETAILLOADINGFAIL,
    payload,
});

export const setIsSessionLoading = (payload: any) => ({
    type: actionTypes.SET_ISSESSIONLOADING,
    payload,
});

export const setSessionLoadingFail = (payload: any) => ({
    type: actionTypes.SET_SESSIONLOADINGFAIL,
    payload,
});

export const setCalendarErrorMsg = (payload: string) => ({
    type: actionTypes.SET_CALENDARERRORMSG,
    payload,
});

export const setSessionErrorMsg = (payload: string) => ({
    type: actionTypes.SET_SESSIONERRORMSG,
    payload,
});

export const setTicketErrorMsg = (payload: string) => ({
    type: actionTypes.SET_TICKETERRORMSG,
    payload,
});

export const setScrollTo = (payload: any) => ({
    type: actionTypes.SET_SCROLLTO,
    payload,
});

export const setSubmitWatcher = (payload: any) => ({
    type: actionTypes.SET_SUBMITWATCHER,
    payload,
});

export const setIsSubmitSuccess = (payload: any) => ({
    type: actionTypes.SET_ISSUBMITSUCCESS,
    payload,
});

// 自建
export const setOpenNvbRslb = (payload: any) => ({
    type: actionTypes.SET_OPENNVBRSLB,
    payload,
});

export const setAllSessions = (payload: any) => ({
    type: actionTypes.SET_ALLSESSIONS,
    payload,
});

export const setDisabledSessions = (payload: any) => ({
    type: actionTypes.SET_DISABLEDSESSIONS,
    payload,
});

export const setPickSession = (payload: any) => ({
    type: actionTypes.SET_PICKSESSION,
    payload,
});

export const setDisabledDateBySession = (payload: any) => ({
    type: actionTypes.SET_DISABLEDDATEBYSESSION,
    payload,
});

export const setMinDate = (payload: any) => ({
    type: actionTypes.SET_MINDATE,
    payload,
});

export const setNullDate = (payload: any) => ({
    type: actionTypes.SET_NULLDATE,
    payload,
});

export const setDisabledDate = (payload: any) => ({
    type: actionTypes.SET_DISABLEDDATE,
    payload,
});

export const setSoldoutDate = (payload: any) => ({
    type: actionTypes.SET_SOLDOUTDATE,
    payload,
});

export const setETItemData = (payload: any) => ({
    type: actionTypes.SET_ETITEMDATA,
    payload,
});
/*
// GDS
// 完全回到initstate
export const setGRestore = () => ({
    type: actionTypes.SET_GRESTORE,
});

// 重置選項，若有月曆回到預選第一天
export const setGReset = () => ({
    type: actionTypes.SET_GRESET,
});

export const setCalendar = (payload: any) => ({
    type: actionTypes.SET_CALENDAR,
    payload,
});

export const setSession = (payload: any) => ({
    type: actionTypes.SET_GSESSION,
    payload,
});

export const setSessionPicked = (payload: any) => ({
    type: actionTypes.SET_GSESSIONPICKED,
    payload,
});

export const setGDetail = (payload: any) => ({
    type: actionTypes.SET_GDETAIL,
    payload,
});

export const setGTempCalendarData = (payload: any) => ({
    type: actionTypes.SET_GTEMPCALENDARDATA,
    payload,
});

export const setGCalenderRef = (payload: any) => ({
    type: actionTypes.SET_GCALENDARREF,
    payload,
});

export const setIsGDSDetailLoading = (payload: any) => ({
    type: actionTypes.SET_ISGDSDETAILLOADING,
    payload,
});

export const setGDSDetailFetchFail = (payload: any) => ({
    type: actionTypes.SET_GDSDETAILFETCHFAIL,
    payload,
});

export const setIsGDSSessionLoading = (payload: any) => ({
    type: actionTypes.SET_ISGDSSESSIONLOADING,
    payload,
});

export const setGDSSessionFetchFail = (payload: any) => ({
    type: actionTypes.SET_GDSSESSIONFETCHFAIL,
    payload,
});

export const setGNowList = (payload: any) => ({
    type: actionTypes.SET_GNOWLIST,
    payload,
});

export const setGNowListData = (payload: any) => ({
    type: actionTypes.SET_GNOWLISTDATA,
    payload,
});

export const setGCalenderErr = (payload: string) => ({
    type: actionTypes.SET_GCALENDARERR,
    payload,
});

export const setGSessionErr = (payload: string) => ({
    type: actionTypes.SET_GSESSIONERR,
    payload,
});

export const setGTicketErr = (payload: string) => ({
    type: actionTypes.SET_GTICKETERR,
    payload,
});
*/